module.exports = __webpack_public_path__ + "static/img/rhino_logo.743cc9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rhino_logo.png
// module id = ku+q
// module chunks = 35